import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const deleteRole = async (roleId: string) => {
	const response = await cmsClient.delete(`/roles/${roleId}/`);
	return response.data;
};

const useDeleteRole = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(<CustomToast type="Success" message="Role deleted" />, {
			hideProgressBar: true
		});
	};

	const onSettled = () => {
		queryClient.invalidateQueries(["roles"]);
	};

	const onError = (error: unknown) => {
		const detail = (error as { response?: { data?: Record<string, unknown> } })
			?.response?.data;
		const message =
			(detail as { detail?: string })?.detail ??
			(detail ? Object.values(detail).flat().join(" ") : undefined) ??
			"Something went wrong, try again";

		toast.error(<CustomToast type="Error" message={message} />, {
			hideProgressBar: true
		});
	};

	const mutation = useMutation(deleteRole, {
		onError,
		onSuccess,
		onSettled
	});

	return mutation;
};

export default useDeleteRole;
